// App.js
import "./App.css";

import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import AudioManagementPage from "./pages/AudioManagementPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import RegistrationPage from "./pages/RegistrationPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import CharactersConteinerPage from "./pages/CharactersConteinerPage";
import NotFoundPage from "./pages/NotFoundPage";
import AboutPage from "./pages/AboutPage";
import AdminPanel from "./pages/AdminPanel";
import { useGlobalState } from "./context/GlobalStateContext";
import { getAudioList } from "./services/audios";

function App() {
  const { listAudios, setListAudios } = useGlobalState();

  useEffect(() => {
    const fetchAudioList = async () => {
      // Non fare nulla se abbiamo già i dati
      if (listAudios !== null) return;

      try {
        const data = await getAudioList();
        setListAudios(data);
      } catch (err) {
        console.error("Error fetching audio list:", err);
      }
    };

    fetchAudioList();
  }, [listAudios, setListAudios]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/new-user" element={<RegistrationPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/characters/*" element={<CharactersConteinerPage />} />
        <Route path="/audio" element={<AudioManagementPage />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
